export class MembersFollowup {
  memberIds: number[];
  addFollowupDto: addFollowupDto;
  assignees: number[];
}

export class addFollowupDto {
  memberId: number;
  planDate: Date;
  actualDate: Date;
  activity: number;
  status: number;
  assigner: number;
  assignerComment: string;
  assignee: number;
  assigneeComment: string;
  createdBy: string;
  creationDate: Date;
}
